import React from "react";
import { Link, useLocation } from "react-router-dom";

// There was no catch-all route, so <Routes> rendered nothing for any path it
// did not recognise. The nav and footer stayed put and the middle of the page
// went empty — which from the other side of the screen is indistinguishable
// from a button that does nothing, and is exactly how the broken "Manage" link
// presented. A path that matches nothing should say so.

export default function NotFound() {
    const { pathname } = useLocation();

    return (
        <div className="wb-page wb-page--narrow">
            <h1>That page does not exist</h1>
            <p className="wb-sub">
                Nothing is routed at <code>{pathname}</code>. If you followed a link
                inside the app rather than typing this, it is a bug on our side.
            </p>
            <div className="wb-row" style={{ marginTop: "1.5rem" }}>
                <Link to="/" className="wb-btn wb-btn--primary">Back to home</Link>
                <Link to="/devices" className="wb-btn wb-btn--secondary">Browse screens</Link>
            </div>
        </div>
    );
}
